import { createTheme, type Theme } from '@mui/material/styles';
import { deDE as coreDe, enUS as coreEn, srRS as coreSr } from '@mui/material/locale';
import type { Language } from '@/i18n';

const CORE_LOCALES = { en: coreEn, de: coreDe, sr: coreSr };

/** Calm, data-dense compliance UI: neutral surfaces, one blue accent, semantic colors only for risk/status. */
export function buildTheme(mode: 'light' | 'dark', language: Language): Theme {
  return createTheme(
    {
      palette: {
        mode,
        primary: { main: mode === 'light' ? '#1a56db' : '#6b9bff' },
        background: mode === 'light' ? { default: '#f6f7f9', paper: '#ffffff' } : { default: '#0f1216', paper: '#171b21' },
        divider: mode === 'light' ? '#e4e7ec' : '#2a3039',
      },
      shape: { borderRadius: 10 },
      typography: {
        fontFamily: '"Roboto", "Segoe UI", system-ui, sans-serif',
        h5: { letterSpacing: '-0.01em' },
        button: { textTransform: 'none', fontWeight: 600 },
      },
      components: {
        MuiPaper: { defaultProps: { elevation: 0 } },
        MuiAppBar: { defaultProps: { elevation: 0 } },
        MuiButton: { defaultProps: { disableElevation: true } },
        MuiTextField: { defaultProps: { size: 'small' } },
        MuiChip: { styleOverrides: { root: { fontWeight: 500 } } },
      },
    },
    CORE_LOCALES[language],
  );
}
